<template>
    <div>
        <header id="header">
            <div class="container">
                <div class="">
                    <h1 class="h2">{{ group.name }}</h1>
                </div>
                <div class="actions">          
                    <router-link class="btn btn-small" :to="{ name: 'edit-group'}" v-if="!category && group.can.edit">Group settings</router-link>
                    <a v-on:click.stop.prevent="openModal('edit-category')" class="btn btn-small" v-if="category && group.can.edit">Edit category</a>
                    <router-link class="btn btn-primary btn-small" :to="{ name: 'new-post'}" v-if="group.can.createPosts">New post</router-link>

                    <category-modal :category="category" categoryType="category" v-on:edit-category="updateCategories"></category-modal>
                </div>
            </div>
            
            <nav class="container">
                <ul>
                    <li><router-link :to="{ name: 'view-group', params: { group: group.slug }}">All</router-link></li>
                    <li v-for="cat in group.categories">
                        <router-link :to="{ name: 'view-category', params: { group: group.slug, category: cat.slug }}">{{cat.name}}</router-link>
                    </li>
                    <li v-if="group.can.edit">
                        <a v-on:click.stop.prevent="openModal('new-category')" href="#" class="add"><i class="icon ion-md-add"></i> Add a category</a>
                        <category-modal :category="new_category" categoryType="category" v-on:new-category="insertCategory"></category-modal>
                    </li>
                </ul>
            </nav>
        </header>

        <div class="container">

            <div class="grid">
                <div class="col-md-9">
                    <div class="panel">
                        <div class="forum-post" v-for="post in posts">
                            <router-link :to="{ name: 'view-post', params: { group: group.slug, post: post.slug }}">
                                <h2>{{ post.title }}</h2>
                            </router-link>
                            <div class="byline">
                                <avatars :users="post.authors" v-if="post.authors"></avatars>
                                {{ formatDate(post.published_at) }} <span class="replies">{{ post.comments_count }} replies</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <vuetable-pagination 
                ref="pagination"
                @vuetable-pagination:change-page="onChangePage"
            ></vuetable-pagination>
        </div>
    </div>
</template>

<script>
    import qs from 'qs';
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
    import PaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin';
    import MicroModal from 'micromodal';
    import { format, formatDistance, parse } from 'date-fns';

    export default {
        props: ['group', 'category'],
        components: {
            VuetablePagination
        },
        data(){
            return {
                posts: [],
                new_category: null,
                page: 0
            }
        },
        watch: {
            category: {
                deep: true,
                handler() {
                    this.getPosts();
                }
            }
        },
        mounted() {
            this.getPosts();
        },
        methods: {
            openModal(modal){
                MicroModal.show(modal);
            },
            onChangePage(page) {
                this.page = page;
                this.getPosts();
            },
            getPosts() {
                var queryString = qs.stringify({
                    page: this.page,
                    category: this.category
                });

                axios.get('/api/groups/' + this.group.slug + '/posts?' + queryString).then((response) => {
                    this.posts = response.data.data;
                    
                    if( this.$refs.pagination ){
                        this.$refs.pagination.setPaginationData(response.data);
                    }
                }, (response) => {
                    this.error = response;
                });
            },
            updateCategories(category){
                this.group.categories.forEach((cat, index) => {
                    if(cat.id === category.id) {
                        this.$set(this.group.categories, index, category);
                    }
                });
            },
            insertCategory(category){
                this.$set(this.group.categories, this.group.categories.length, category);
            },
            formatDate(date){
                if(date){
                    date = parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());
                    if(this.group.type == 4){
                        return format(date, 'E do LLL yyyy');
                    }

                    return format(date, 'do LLL yyyy');
                }
            },
        }
    }
</script>